import { render, staticRenderFns } from "./cardDelivery.vue?vue&type=template&id=75743630&scoped=true"
import script from "./cardDelivery.vue?vue&type=script&lang=js"
export * from "./cardDelivery.vue?vue&type=script&lang=js"
import style0 from "./cardDelivery.vue?vue&type=style&index=0&id=75743630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75743630",
  null
  
)

export default component.exports